import { createContext, useState, useEffect } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({children})=>{
    const [auth,setAuth] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Retrieve token from localStorage on app initialization
        const storedAuth = JSON.parse(localStorage.getItem('auth'));
        if (storedAuth) {
            setAuth(storedAuth);
        }
        setLoading(false);
    }, []);

    useEffect(()=> {
        localStorage.setItem('auth', JSON.stringify(auth));
    }, [auth]);

    const login = (newAuth) => {
        setAuth(newAuth);
      };
    
    const logout = () => {
        localStorage.removeItem('auth');
        setAuth({});
      };

    return (
        <AuthContext.Provider value={{ auth, setAuth, login, logout, loading }}>
        {children}
        </AuthContext.Provider>
    );

};

export default AuthContext;